import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';

export const Footer = props => {
  return <LazyLoaderWrapper testId='account-container-test' importPath='FOOTER_PAGE' {...props}></LazyLoaderWrapper>;
};
